import { OrgAlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';
import { mainOrgSearchRouteReference } from 'modules/main/main.routes';
import { HOME_PAGE_SLUGS } from 'utils/constants/general/homePageSlugs';

import { transformSearchFiltersToQueryParams } from './transformSearchFiltersToQueryParams';

type MainOrgSearchRouteData = {
  lang: UserLocale;
  q?: string;
  radius?: number | 'auto' | null;
  saved?: boolean;
  filters?: OrgAlgoliaApiQueryFilters;
};

export function getMainOrgSearchRoutePath(data: MainOrgSearchRouteData) {
  const { lang, filters, q, radius, saved } = data;

  // Extract the segment based on type
  const segment = HOME_PAGE_SLUGS.ORG[lang];

  const queryParams: Record<string, unknown> = {};

  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (typeof saved !== 'undefined') queryParams.saved = saved;

  if (filters) {
    // Merge basic and filter-derived query parameters
    Object.assign(queryParams, transformSearchFiltersToQueryParams(filters));
  }

  return mainOrgSearchRouteReference.with({
    lang,
    segment,
    ...queryParams,
  });
}
